export default {
  phoneNumber: [
    {
      key: "required",
      message: "Mobilnummer eller reskortsnummer är obligatoriskt.",
      id: "phoneRequired",
    },
    {
      key: "phoneNumberFormat",
      message: "Felaktigt format på mobilnummer",
      id: "phoneNumberFormat",
    },
    {
      key: "maxLength",
      message: "Mobilnummer får inte vara mer än 30 tecken långt.",
      id: "mobileLength",
    },
  ],
  name: [
    {
      key: "required",
      message: "Namn är obligatoriskt.",
      id: "nameRequired",
    },
    {
      key: "maxLength",
      message: "Namn får inte vara mer än 100 tecken långt.",
      id: "nameLength",
    },
  ],
  cardNumber: [
    {
      key: "required",
      message: "Mobilnummer eller reskortsnummer är obligatoriskt.",
      id: "cardNumberRequired",
    },
    {
      key: "numericLength",
      message: "Felaktigt format på reskortsnummer.",
      id: "cardNumberNumeric",
    },
  ],
};
